import { isTouchDevice } from './_mediaZoom.utils';
import Hammer from 'hammerjs';
export default {
  zoom: {
    min: 100,
    //%
    max: 400,
    //%
    step: 50,
    //%
    wheel_speed: 1.5 // times the mousewheel deltaY
  },
  // https://hammerjs.github.io/getting-started/
  hammer: {
    pan: {
      enable: true,
      threshold: 3,
      pointers: 1,
      direction: Hammer.DIRECTION_ALL
    },
    tap: {
      enable: true,
      pointers: 1,
      taps: isTouchDevice() ? 2 : 1,
      // on mobile it needs 3 taps to work ! ¯\_(ツ)_/¯
      interval: 500,
      time: 300,
      threshold: 10,
      posThreshold: 50
    },
    pinch: {
      enable: isTouchDevice(),
      pointers: 2,
      threshold: 0
    },
    swipe: {
      enable: isTouchDevice(),
      pointers: 1,
      threshold: 150,
      velocity: 0.75,
      direction: Hammer.DIRECTION_HORIZONTAL
    }
  }
};